(function($) {
    $(document).ready(function() {
        initMaxHeight();
    });

    $(window).resize(function() {
        initMaxHeight();
    });

    function initMaxHeight() {
        maxHeight = 0;

        $(' .article-column:not(:first-child)').each(function() {
            $(this).find('.right-side').each(function() {
                var height = $(this).outerHeight();

                if (height > maxHeight) {
                    maxHeight = height;
                }
            });

        });

        $('.article-column:not(:first-child) .right-side').css('min-height', maxHeight + 'px');
    }
})(jQuery)